window.addEventListener('load', () => {
    AOS.init();
    let scrollRef = 0;
});


jQuery(document).ready(function($){

    // $('.menu-toggle').click(function(){
    //     $(".mobile-nav-ul").toggleClass("mobile-nav");
    //     $(this).toggleClass("is-active");
    // });


    $(document).on('focus', '.ninja-forms-field', function (e) {
        e.preventDefault();
        $(this).closest('.field-wrap').addClass('focused');
    });

    $(document).on('blur', '.ninja-forms-field', function (e) {
        e.preventDefault();
        var $wrap = $(this).closest('.field-wrap');
        var $input = $wrap.find('.nf-field-element .ninja-forms-field');
        if ($input.val().length == 0)
            $wrap.removeClass('focused');
    });

    $('.card-body').hide();

    $(document).on('click', '.faq-accordion-card .card-top', function (e) {
        var $this = $(this);
        var $activeCard = $('.faq-accordion-card.card-active');
        var $parentCard = $this.closest('.faq-accordion-card');
        console.log($activeCard);

        if ($parentCard.hasClass('card-active')) {
            $parentCard.removeClass('card-active').find('.card-body').slideUp();
        } else {
            $activeCard.removeClass('card-active').find('.card-body').slideUp();
            $parentCard.addClass('card-active').find('.card-body').slideDown();
        }
    });


});

